import { CourseCompletionStatus } from '../trackingClient';

export class TrackedData {
  private _lastAccessedTimeInMilliseconds: number;

  public getLog() {
    return this.log;
  }
  public getTimeSpentInCourse() {
    return this.timeSpentInCourse;
  }
  public getStartedCourseAt() {
    return this.startedCourseAt;
  }
  public getLastAccessedTimeAt() {
    return this.lastAccessedTime;
  }
  public getCompletedCourseAt() {
    return this.completedCourseAt;
  }

  constructor(
    private timeSpentInCourse: number,
    private log: string,
    private startedCourseAt: number | null,
    private lastAccessedTime: number | null,
    private completedCourseAt: number | null,
    private readonly dateNowFunction: () => number = Date.now
  ) {
    this._lastAccessedTimeInMilliseconds = this.dateNowFunction();
  }

  /** Updates tracking log and re-calculates tracking data. */
  public updateTrackingLog(log: string) {
    this.lastAccessedTime = this.dateNowFunction();
    if (!this.startedCourseAt) {
      this.startedCourseAt = this.lastAccessedTime;
    }

    this.timeSpentInCourse = this._computeTimeSpent(this.lastAccessedTime);
    this.log = log;
  }

  /** Sets completion state. Returns true when student just completed the course. */
  public setCompletionStatus(status: CourseCompletionStatus): boolean {
    if (this.completedCourseAt === null && status === CourseCompletionStatus.Completed) {
      this.completedCourseAt = this.dateNowFunction();

      return true;
    }

    return false;
  }

  private _computeTimeSpent = (currentTimeInMilliseconds: number): number => {
    const timeSpent = this.timeSpentInCourse + (currentTimeInMilliseconds - this._lastAccessedTimeInMilliseconds);
    this._lastAccessedTimeInMilliseconds = currentTimeInMilliseconds;
    return timeSpent;
  };
}
